import type { AdminAuditLogFilters } from '@/api/models';

/** Count of active audit-log filters, for the `FiltersPopover` badge. Excludes pagination. */
export function countActiveAuditLogFilters(filters: AdminAuditLogFilters): number {
  return [
    filters.dateFrom,
    filters.dateTo,
    filters.actor,
    filters.actorType?.length,
    filters.action?.length,
    filters.objectType,
    filters.objectId,
    filters.tenantCode?.length,
  ].filter((value) => Boolean(value)).length;
}
